import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import '@/lib/i18n';
import '@/styles/globals.css';
import { FALLBACK_THEME, applyTheme } from '@/themes/theme-runtime';

// Aplica tema imediatamente pra evitar flash
applyTheme(FALLBACK_THEME);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
